import { z } from "zod";

const ResetDefaultColorResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(z.string()),
});

export { ResetDefaultColorResponse };
export type ResetDefaultColorData = z.infer<typeof ResetDefaultColorResponse>;